import { useQuery } from "@tanstack/react-query";
import { auditLogsApi } from "@/services/api";

interface AuditLogFilters {
  entity_type?: string;
  entity_id?: number;
  user_id?: number;
  action?: string;
  date_from?: string;
  date_to?: string;
  skip?: number;
  limit?: number;
}

export function useAuditLogs(filters: AuditLogFilters = {}) {
  return useQuery({
    queryKey: ["audit-logs", filters],
    queryFn: async () => {
      const response = await auditLogsApi.list(filters);
      return response.data;
    },
  });
}
